// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4958":"779e9c15","5926":"1e86f28b","9724":"58d3d23f"}[chunkId] + ".chunk.css";
};